import React from "react"
import { Chip } from "material-ui"
import autobind from "class-autobind"
import ToolTip from "react-portal-tooltip"
import WarningIcon from "material-ui/svg-icons/alert/warning"
import { amberA400 } from "material-ui/styles/colors"
import moment from "moment"
import AppStateStore from "../../stores/AppStateStore"
import strings from "../../localization/strings"
import * as api from "../../api"

interface IProps {
    keyStr: string | number
    suspenseReason: string
    // it's real timezone time
    value: string
    punchId: string
    readonly: boolean
    reloadTimecard(msg: string): void
}
interface IState {
    open: boolean
}

export default class TimecardSuspensePunchChip extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            open: false
        }
        autobind(this)
    }

    handleDeleteRejectSuspensePunch() {
        AppStateStore.setConfirmDialogContent({
            content: this.props.suspenseReason === strings.Edit_punch_time_from_mobile ?
                strings.Are_you_sure_you_want_to_reject_this_suspense_punch_time :
                strings.Are_you_sure_you_want_to_delete_this_suspense_punch,
            confirm: () => {
                AppStateStore.setProgressSnackbarContent("loading")
                api.deleteRejectSuspensePunches([this.props.punchId]).then(() => {
                    AppStateStore.setProgressSnackbarContent(null)
                    this.props.reloadTimecard &&
                        this.props.reloadTimecard(null)
                })
            }
        })
    }

    render() {
        return (
            <div>
                <ToolTip active={this.state.open} position="bottom" arrow="center" parent={`#suspense-${this.props.keyStr}`}>
                    <div style={{ paddingLeft: 15, paddingRight: 15, textAlign: "center" }}>
                        <ul style={{ paddingInlineStart: 10 }}>
                            <li>
                                {this.props.suspenseReason}
                            </li>
                        </ul>
                    </div>
                </ToolTip>
                <div id={`suspense-${this.props.keyStr}`}>
                    <Chip
                        onRequestDelete={this.props.readonly ? null : this.handleDeleteRejectSuspensePunch}
                        style={{ height: 20, backgroundColor: amberA400 }}
                        labelStyle={{ paddingLeft: 3, fontSize: 12, fontWeight: 500, color: "white", display: "flex", alignItems: "center" }}
                        deleteIconStyle={{ width: 15, height: 15, fill: "white", marginTop: 3, marginLeft: -9, marginRight: 2 }}
                        onMouseOver={() => this.setState({ open: true })}
                        onMouseOut={() => this.setState({ open: false })}
                    >
                        <WarningIcon
                            style={{ color: "white", width: 14, height: 14 }}
                        />
                        {moment(this.props.value).parseZone().format("hh:mma")}
                    </Chip>
                </div>
            </div>
        )
    }
}